/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cipher_Transition_Rotation_ActiveInputs */

const bn_cipher_transition_rotation_active = /** @type {(inputs: Cipher_Transition_Rotation_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সক্রিয়`)
};

const de_cipher_transition_rotation_active = /** @type {(inputs: Cipher_Transition_Rotation_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AKTIV`)
};

const el_cipher_transition_rotation_active = /** @type {(inputs: Cipher_Transition_Rotation_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ΕΝΕΡΓΟΣ`)
};

const en_cipher_transition_rotation_active = /** @type {(inputs: Cipher_Transition_Rotation_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ACTIVE`)
};

const es_cipher_transition_rotation_active = /** @type {(inputs: Cipher_Transition_Rotation_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ACTIVO`)
};

const fr_cipher_transition_rotation_active = /** @type {(inputs: Cipher_Transition_Rotation_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ACTIF`)
};

const hi_cipher_transition_rotation_active = /** @type {(inputs: Cipher_Transition_Rotation_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सक्रिय`)
};

const hu_cipher_transition_rotation_active = /** @type {(inputs: Cipher_Transition_Rotation_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AKTÍV`)
};

const id_cipher_transition_rotation_active = /** @type {(inputs: Cipher_Transition_Rotation_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AKTIF`)
};

const it_cipher_transition_rotation_active = /** @type {(inputs: Cipher_Transition_Rotation_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATTIVO`)
};

const ja_cipher_transition_rotation_active = /** @type {(inputs: Cipher_Transition_Rotation_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクティブ`)
};

const ko_cipher_transition_rotation_active = /** @type {(inputs: Cipher_Transition_Rotation_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`활동적인`)
};

const nl_cipher_transition_rotation_active = /** @type {(inputs: Cipher_Transition_Rotation_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ACTIEF`)
};

const pl_cipher_transition_rotation_active = /** @type {(inputs: Cipher_Transition_Rotation_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AKTYWNY`)
};

const pt_cipher_transition_rotation_active = /** @type {(inputs: Cipher_Transition_Rotation_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATIVO`)
};

const ru_cipher_transition_rotation_active = /** @type {(inputs: Cipher_Transition_Rotation_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`АКТИВНЫЙ`)
};

const sv_cipher_transition_rotation_active = /** @type {(inputs: Cipher_Transition_Rotation_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AKTIV`)
};

const tr_cipher_transition_rotation_active = /** @type {(inputs: Cipher_Transition_Rotation_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AKTİF`)
};

const uk_cipher_transition_rotation_active = /** @type {(inputs: Cipher_Transition_Rotation_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`АКТИВНИЙ`)
};

const vi_cipher_transition_rotation_active = /** @type {(inputs: Cipher_Transition_Rotation_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TÍCH CỰC`)
};

const zh_cipher_transition_rotation_active = /** @type {(inputs: Cipher_Transition_Rotation_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`积极的`)
};

const zh_hant_cipher_transition_rotation_active = /** @type {(inputs: Cipher_Transition_Rotation_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`積極的`)
};

/**
* | output |
* | --- |
* | "ACTIVE" |
*
* @param {Cipher_Transition_Rotation_ActiveInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const cipher_transition_rotation_active = /** @type {((inputs?: Cipher_Transition_Rotation_ActiveInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cipher_Transition_Rotation_ActiveInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_cipher_transition_rotation_active(inputs)
	if (locale === "de") return de_cipher_transition_rotation_active(inputs)
	if (locale === "el") return el_cipher_transition_rotation_active(inputs)
	if (locale === "en") return en_cipher_transition_rotation_active(inputs)
	if (locale === "es") return es_cipher_transition_rotation_active(inputs)
	if (locale === "fr") return fr_cipher_transition_rotation_active(inputs)
	if (locale === "hi") return hi_cipher_transition_rotation_active(inputs)
	if (locale === "hu") return hu_cipher_transition_rotation_active(inputs)
	if (locale === "id") return id_cipher_transition_rotation_active(inputs)
	if (locale === "it") return it_cipher_transition_rotation_active(inputs)
	if (locale === "ja") return ja_cipher_transition_rotation_active(inputs)
	if (locale === "ko") return ko_cipher_transition_rotation_active(inputs)
	if (locale === "nl") return nl_cipher_transition_rotation_active(inputs)
	if (locale === "pl") return pl_cipher_transition_rotation_active(inputs)
	if (locale === "pt") return pt_cipher_transition_rotation_active(inputs)
	if (locale === "ru") return ru_cipher_transition_rotation_active(inputs)
	if (locale === "sv") return sv_cipher_transition_rotation_active(inputs)
	if (locale === "tr") return tr_cipher_transition_rotation_active(inputs)
	if (locale === "uk") return uk_cipher_transition_rotation_active(inputs)
	if (locale === "vi") return vi_cipher_transition_rotation_active(inputs)
	if (locale === "zh") return zh_cipher_transition_rotation_active(inputs)
	return zh_hant_cipher_transition_rotation_active(inputs)
});